import { Link } from "react-router-dom";
import type { Article } from "@/types/content";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

interface LatestSectionProps {
  articles: Article[];
}

const hotTags = [
  "雨戏",
  "夜戏",
  "群戏",
  "剪辑节奏",
  "围读",
  "导播切换",
  "服化道",
  "现场收音",
  "机位",
  "生活制片",
];

export default function LatestSection({ articles }: LatestSectionProps) {
  return (
    <section className="max-w-portal mx-auto px-4 md:px-6 pt-12 md:pt-16">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
        <div className="lg:col-span-2">
          <SectionHeading
            eyebrow="Latest Stories"
            title="最新爆料"
            desc="按发布时间排列的幕后稿件，第一时间补上镜头之外的剧情。"
          />
          <div>
            {articles.map((item) => (
              <ArticleCard key={item.id} article={item} variant="horizontal" />
            ))}
          </div>
          <Link
            to="/category/backstage"
            className="inline-flex items-center gap-1.5 mt-6 px-5 py-2.5 rounded-md border-2 border-foreground-950 text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-foreground-950 hover:text-background-50 transition-colors"
          >
            浏览全部幕后故事
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <aside className="space-y-6">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5">
            <h3 className="font-heading text-base font-bold text-foreground-950 mb-4">
              热门标签
            </h3>
            <div className="flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium hover:bg-secondary-200 transition-colors cursor-pointer"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-lg bg-primary-50 border border-primary-200 p-5">
            <h3 className="font-heading text-base font-bold text-foreground-950 mb-3">
              一周更新节奏
            </h3>
            <ul className="space-y-3 text-sm text-foreground-700">
              <li className="flex items-center justify-between">
                <span>综艺幕后</span>
                <span className="font-bold text-foreground-950">每周 2 篇</span>
              </li>
              <li className="flex items-center justify-between">
                <span>影视探班</span>
                <span className="font-bold text-foreground-950">每周 2 篇</span>
              </li>
              <li className="flex items-center justify-between">
                <span>剪辑与现场</span>
                <span className="font-bold text-foreground-950">每周 1 篇</span>
              </li>
            </ul>
            <p className="text-xs text-foreground-500 leading-relaxed mt-4">
              热播期会临时加密更新，具体以首页「最新爆料」为准。
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}